/*
 * premierstreets
 * version 4.5
 * http://www.premierstreets.com
 *
 * Copyright (c) 2021 premier streets
 * Author premier streets <support@premierstreets.com>
 * Licensed under the MIT license.
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Api } from '../providers/api/api';

@Injectable()
export class CommonService extends Api {
  // private base: string = this.getBaseUrl();
  private base: string;

  /* get wishlist count api*/
  public getWishlistCount(params: any): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.get(this.base + 'customer/wishlist-product-list', {
      params: params
    });
  }

  /* get profile api*/
  public doGetProfile(params: any): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.get(this.base + 'customer/get-profile');
  }

  /* get profile api*/
  public getUser(params: any): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.get(this.base + 'customer/get-user', { params: params });
  }

  /* create booking request*/
  public createBooking(params: any): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.post(this.base + 'vendor/booking-request/create', params);
  }

  /* create booking request*/
  public unsubscribeUser(params: any): Observable<any> {
    this.base = this.getBaseUrl();
    //return this.http.get(this.base + 'vendor/unsubscribe-user', params);
    return this.http.get(this.base + 'vendor/unsubscribe-user', {
      params: params
    });

  }

  public getBundleProducts(params: any): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.get(this.base + 'vendor-product/get-bundle-products', {
      params: params
    });
  }

  /* get language api*/
  public getLanguage(params: any): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.get(this.base + 'list/language-list', { params: params });
  }

  public getVendorDetail(): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.get(this.base + 'vendor/vendor-detail');
  }

  public getSiteSetting(): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.get(this.base + 'vendor/site-setting-guest');
  }

  public getInviteFreeProduct(): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.get(this.base + 'invited-customer/free-product');
  }

  public referAFriend(params: any): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.post(this.base + 'invited-customer/add', params);
  }


  public getSingleTicket(params: any): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.get(this.base + 'customer/get-single-ticket/' + params);
  }

  /* create vendor post api*/
  public shareChatUrl(params: any): Observable<any> {
    console.log("share chat url");
    console.log(params);
    return this.http.post(this.base + 'user-post/send-customer-email-for-frontend', params);
  }

  public getEmailTicketsChats(params: any): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.post(this.base + 'user-post/get-user-emails-for-customer', params);
  }


  public getTickets(params: any): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.get(this.base + 'customer/customer-get-tickets/1', { params: params });
  }

  public getTicketDetails(chatId: any, type: any, ticketId: any): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.get(this.base + 'customer/get-tickets-chats-customer/' + chatId + '/' + type + '/' + ticketId);
  }

  /* customer log out*/
  public customerLogOut(params: any): Observable<any> {
    this.base = this.getBaseUrl();
    return this.http.get(this.base + 'customer/logout');
  }

  public addNewsletter(params: any): Observable<any> {
    return this.http.post(this.base + 'wishlist/add/customer/email/vender', params);
  }


}
